/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function () {
  // Add custom code below this line

  function getSidePrintCount(popupSelectElement) {
    if (!popupSelectElement) return null;
    const selectedOptionEl = popupSelectElement.querySelector('.selected-option');
    if (!selectedOptionEl || !selectedOptionEl.classList.contains('selected')) {
      return null; // Not selected yet
    }
    const text = selectedOptionEl.textContent.toLowerCase().trim();
    if (text.includes('dou') || text.includes('duo')) {
      return 2;
    } else if (text.includes('trio')) {
      return 3;
    } else {
      return 1; // Classic or others count as 1 print
    }
  }

  function selectPrintsOption(totalPrints) {
    const printsWrapper = document.querySelector('[data-prints-option-wrapper]');
    
    if (!printsWrapper) {
      console.log('selectPrintsOption: prints option wrapper not found.');
      return;
    }
    
    console.log('selectPrintsOption: found prints wrapper:', printsWrapper);
    
    const radioInputs = printsWrapper.querySelectorAll('input[type="radio"]');
    const popoutOptions = printsWrapper.querySelectorAll('[data-popout-option], .select-popout__option');
    
    let targetElement = null;
    
    if (radioInputs.length > 0) {
      for (const input of radioInputs) {
        const valStr = input.value.toString().toLowerCase().trim();
        if (valStr === totalPrints.toString()) {
          targetElement = input;
          break;
        }
        const match = valStr.match(/\b\d+\b/);
        if (match && parseInt(match[0]) === totalPrints) {
          targetElement = input;
          break;
        }
        const words = ["zero", "one", "two", "three", "four", "five", "six"];
        if (words[totalPrints] && valStr.includes(words[totalPrints])) {
          targetElement = input;
          break;
        }
      }
      
      if (targetElement && !targetElement.checked) {
        console.log('selectPrintsOption: checking radio input:', targetElement);
        targetElement.checked = true;
        targetElement.dispatchEvent(new Event('change', { bubbles: true }));
        targetElement.dispatchEvent(new Event('input', { bubbles: true }));
      }
    } 
    else if (popoutOptions.length > 0) {
      for (const option of popoutOptions) {
        const valStr = (option.getAttribute('data-value') || option.textContent || '').toString().toLowerCase().trim();
        if (valStr === totalPrints.toString()) {
          targetElement = option;
          break;
        }
        const match = valStr.match(/\b\d+\b/);
        if (match && parseInt(match[0]) === totalPrints) {
          targetElement = option;
          break;
        }
        const words = ["zero", "one", "two", "three", "four", "five", "six"];
        if (words[totalPrints] && valStr.includes(words[totalPrints])) {
          targetElement = option;
          break;
        }
      }
      
      if (targetElement) {
        const parentLi = targetElement.closest('.select-popout__item');
        if (!parentLi || !parentLi.classList.contains('is-active')) {
          console.log('selectPrintsOption: clicking popout option:', targetElement);
          targetElement.click();
        }
      }
    }
    
    if (!targetElement) {
      console.log('selectPrintsOption: no matching option element found for totalPrints =', totalPrints);
    }
  }

  function updatePrintsOptionState() {
    const side1Popup = document.querySelector('popup-select[data-popup-type="double-sides"][data-popup-index="1"]');
    const side2Popup = document.querySelector('popup-select[data-popup-type="double-sides"][data-popup-index="2"]');
    
    // Only apply if it's a double sided product (both popups exist)
    if (!side1Popup && !side2Popup) return;

    const count1 = side1Popup ? getSidePrintCount(side1Popup) : null;
    const count2 = side2Popup ? getSidePrintCount(side2Popup) : null;
    
    const btnAtc = document.querySelector('[data-add-to-cart]');

    if (side1Popup && side2Popup) {
      if (count1 === null || count2 === null) {
        if (btnAtc) {
          const btnText = btnAtc.textContent.toLowerCase();
          const isSoldOut = btnText.includes('sold out');
          if (!isSoldOut) {
            btnAtc.removeAttribute('disabled');
          } else {
            btnAtc.setAttribute('disabled', 'disabled');
          }
          btnAtc.style.pointerEvents = 'none';
          btnAtc.style.opacity = '0.5';
        }
      } else {
        if (btnAtc) {
          const btnText = btnAtc.textContent.toLowerCase();
          const isSoldOut = btnText.includes('sold out');
          if (!isSoldOut) {
            btnAtc.removeAttribute('disabled');
            btnAtc.style.pointerEvents = 'auto';
            btnAtc.style.opacity = '1';
          } else {
            btnAtc.setAttribute('disabled', 'disabled');
            btnAtc.style.pointerEvents = 'none';
            btnAtc.style.opacity = '0.5';
          }
        }
      }
    }

    let totalPrints = (count1 || 0) + (count2 || 0);
    
    if (totalPrints < 2) {
      totalPrints = 2; // minimum 2 prints
    }
    
    if (totalPrints > 6) {
      totalPrints = 6; // maximum 6 prints
    }
    
    console.log('updatePrintsOptionState: totalPrints =', totalPrints);
    selectPrintsOption(totalPrints);
  }

  // Radio Inputs and Engraving
  const productSelectors = {
    ENGRAVING_ON_BACK: '.js-engraving-on-the-back',
    RADIO_INPUT: '.selector-wrapper .radio__input',
    FREE_FINGERPRINT: '.selector-free-fingerprint',
    BTN_INFO_FINGERPRINT: '.js-show-fingerprint-faqs-modal',
    PRODUCT_INNER_WRAPPER: '.product__wrapper__inner',
    ENGRAVING_DRAWER_CONTENT: '.engraving-drawer__content',
    ENGRAVING_DRAWER: '.engraving-drawer',
    PRODUCT_SUBMIT_ITEM: '.js-product-submit-item',
    SIZE_GUIDE_MODAL: '.size-guide-modal',
  }

  const dataSelectors = {
    BTN_ADD_TO_CART_ENGRAVING: '[data-add-to-cart-engraving]',
    INPUT_BIRTHSTONE: '[data-input-birthstone-option]',
    INPUT_FINGERPRINT: '[data-fingerprint-upload]',
    INPUT_FREE_FINGERPRINT_KIT: '[data-input-free-fingerprint-kit]',
    INPUT_ENGRAVING_STYLE: '[data-input-engraving-style]',
    INPUT_ENGRAVING_FONT: '[data-input-engraving-font]',
    INPUT_ENGRAVING_ON_THE_BACK: '[data-input-engraving-ontheback]',
    DATA_INPUT_ENGRAVED_ROW: '[data-input-engraved-row]',
    DATA_TEXT_INLINE_IMAGE: '[data-text-inline-image]',
    DATA_SVG_TEXT: '[data-svg-text] textPath',
    BTN_FINGERPRINT_FAQ_MODAL: '[data-btn-fingerprint-faqs-modal]',
    SIZE_GUIDE_SWITCH_CONTENT: '[data-switch-content]',
    SIZE_GUIDE_ITEM_CONTENT: '[data-guide-item-content]'
  }

  const classNames = {
    HIDDEN: 'hidden',
    BLOCK: 'block',
    ACTIVE: 'active',
    SELECTED: 'selected',
    DISABLED: 'disabled',
    FLEX: '!flex',
    DOWN_SIZE: 'down-size',
    HAS_ENGRAVING: 'has-engraving',
    HAS_FILE_UPLOAD: 'has-file-upload',
  }

  const attributeSelectors = {
    DATA_TEXT: 'data-text',
    DATA_INDEX: 'data-index',
    DATA_IE_INDEX: 'data-ie-index',
    DATA_IE_TEXT_TYPE: 'data-ie-text-type',
  }

  // Popup Select Component
  const popupSelectSelectors = {
    CONTAINER: '.popup-select-container',
    TRIGGER: '.popup-select-trigger',
    POPUP: '.popup-select-options',
    OPTION: '.popup-select-option',
    SELECTED_OPTION: '.selected-option',
    HIDDEN_INPUT: 'input[type="hidden"]',
    INITIAL_SELECTED: '.popup-select-option[selected]',
    SELECTED_IMAGE: '.js-image-placeholder',
    DATA_IMAGE_OPTION: '[data-image-option]',
    VARIANT_ID: 'data-variant-id',
    VARIANT_PRICE: 'data-price',
    OPTION_DEFAULT: 'data-option-default',
    DATA_POPUP_TYPE: 'data-popup-type',
    DATA_POPUP_INDEX: 'data-popup-index'
  }

  const fonts = ['LCALLIG,sans-serif', 'Melinda Script', 'Azo Sans']

  

  document.addEventListener("DOMContentLoaded", (event) => {
    this.container = document.querySelector(productSelectors.PRODUCT_INNER_WRAPPER);

    if (!this.container) {
      console.warn('Product container not found. Ensure this script runs on product pages.');
      return;
    }

    const radioInputs = this.container.querySelectorAll(productSelectors.RADIO_INPUT);
    const btnAddToCartEngraving = this.container.querySelector(dataSelectors.BTN_ADD_TO_CART_ENGRAVING);
    const fingerprintUploadBox = this.container.querySelector(dataSelectors.INPUT_FINGERPRINT);
    const inputsEngravedRow = this.container.querySelectorAll(dataSelectors.DATA_INPUT_ENGRAVED_ROW);
    const inputsEngraved = this.container.querySelectorAll(`${dataSelectors.DATA_INPUT_ENGRAVED_ROW} input`);
    const textInlineImage = this.container.querySelector(dataSelectors.DATA_TEXT_INLINE_IMAGE);
    const svgTextInlineImage = this.container.querySelector(`${dataSelectors.DATA_SVG_TEXT}`);
    const drawerContent = this.container.querySelector(productSelectors.ENGRAVING_DRAWER_CONTENT);
    const engravingDrawer = this.container.querySelector(productSelectors.ENGRAVING_DRAWER);
    const engravingStyleInput = this.container.querySelector(dataSelectors.INPUT_ENGRAVING_STYLE);
    const engravingFontInput = this.container.querySelector(dataSelectors.INPUT_ENGRAVING_FONT);
    const productSubmitItem = this.container.querySelector(productSelectors.PRODUCT_SUBMIT_ITEM);

    openFingerprintFAQModal()
    onSubmitButtonATC()
    onSubmitProductForm()
    onChangeRadioInput()
    onChangeEngravingInput()
    onVariantChange()
    toggleGuideTable('Circumference')

    // Handle engraving add to cart button
    function onSubmitButtonATC() {
      if (!btnAddToCartEngraving) return;

      btnAddToCartEngraving.addEventListener('click', function (e) {
        e.preventDefault();

        // Get the form associated with this button
        const engravingForm = this.closest('form');
        if (!engravingForm) return;

        const valid = validateSizeOption();
        if (!valid) return;

        const inputEngravingRowActive = engravingDrawer.querySelectorAll(`${dataSelectors.DATA_INPUT_ENGRAVED_ROW}.${classNames.ACTIVE} input`);

        inputEngravingRowActive.forEach((input) => {
          const value = input.value.trim();
          if (value) {
            const propertyName = `properties[${input.name}]`;
            let propertyInput = engravingForm.querySelector(`input[name="${propertyName}"]`);
            if (!propertyInput) {
              propertyInput = document.createElement('input');
              propertyInput.type = 'hidden';
              propertyInput.name = propertyName;
              engravingForm.appendChild(propertyInput);
            }
            propertyInput.value = value;
          }
        });

        // Dispatch the cart add event using the standard theme method
        document.dispatchEvent(
          new CustomEvent('theme:cart:add', {
            detail: {
              button: this
            },
            bubbles: false,
          })
        );

        // Close the engraving drawer after adding to cart
        setTimeout(() => {
          const popupClose = engravingDrawer.querySelector('[data-popup-close]');
          if (popupClose) {
            popupClose.click();
          }
        }, 1000);

        // Listen for successful cart addition to provide feedback
        document.addEventListener('theme:product:add', function handleEngravingSuccess(e) {
          if (e.detail.button === btnAddToCartEngraving) {
            console.log('Product with engraving added to cart successfully');
            // Remove the event listener after it's been triggered once
            document.removeEventListener('theme:product:add', handleEngravingSuccess);
          }
        });

        // Listen for cart addition errors to provide feedback
        document.addEventListener('theme:product:add-error', function handleEngravingError(e) {
          if (e.detail.button === btnAddToCartEngraving) {
            console.error('Failed to add engraved product to cart:', e.detail.response);
            // Don't close the drawer on error so user can try again
            // Remove the event listener after it's been triggered once
            document.removeEventListener('theme:product:add-error', handleEngravingError);
          }
        });
      });
    }

    function onSubmitProductForm() {
      const productForm = document.querySelector('form[data-product-form]');
      if (!productForm) return;

      productForm.addEventListener('submit', function (e) {
        const side1Popup = document.querySelector('popup-select[data-popup-type="double-sides"][data-popup-index="1"]');
        const side2Popup = document.querySelector('popup-select[data-popup-type="double-sides"][data-popup-index="2"]');
        
        if (side1Popup && side2Popup) {
          const count1 = getSidePrintCount(side1Popup);
          const count2 = getSidePrintCount(side2Popup);
          
          if (count1 === null || count2 === null) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
        }
      });
    }

    function validateSizeOption() {
      const inputSizeElement = document.querySelector('[data-select-size-option]')?.querySelector('[data-single-option-selector]');

      if (!inputSizeElement) return true; // No size option to validate

      return inputSizeElement && inputSizeElement.getAttribute('value') !== ''
    }


    function onChangeRadioInput() {
      const self = this
      radioInputs.forEach(input => {
        input.addEventListener('input', function () {
          const valueDowncase = this.value?.toLowerCase();
          if (this.closest(productSelectors.ENGRAVING_ON_BACK) && productSubmitItem) {
            const inputEngravingOnTheBack = self.container.querySelector(dataSelectors.INPUT_ENGRAVING_ON_THE_BACK);
            inputEngravingOnTheBack.value = valueDowncase;

            if (valueDowncase === 'yes') {
              productSubmitItem.classList.add(classNames.HAS_ENGRAVING);
            } else {
              productSubmitItem.classList.remove(classNames.HAS_ENGRAVING);
            }
          }

          if (this.closest(productSelectors.FREE_FINGERPRINT) && fingerprintUploadBox) {
            if (valueDowncase?.includes('yes')) {
              fingerprintUploadBox.classList.remove(classNames.BLOCK);
            } else {
              fingerprintUploadBox.classList.add(classNames.BLOCK);
            }

            updateButtonAddToCart(valueDowncase)
          }

          if (this.name === 'engraving-options-style' && this.dataset.index) {
            onChangeOptionStyle(parseInt(this.dataset.index), this.value);
          }

          if (this.name === 'engraving-options-fonts') {
            onChangOptionFont(this.value);
          }

          if (this.name === 'free_fingerprint_kit_name') {
            const freeFingerprintKitInputs = self.container.querySelectorAll(dataSelectors.INPUT_FREE_FINGERPRINT_KIT);

            freeFingerprintKitInputs.forEach(input => {
              input.value = this.value.toLowerCase();
            });
          }
        });
      });
    }

    function validateFreeFingerKit() {
      const freeFingerprintKit = this.container.querySelector('[data-fingerprint-upload]')
      return freeFingerprintKit?.classList?.contains('block') && freeFingerprintKit.getAttribute('data-has-value') === 'false'
    }

    function updateButtonAddToCart() {
      const btnAtcTexts = this.container.querySelectorAll('[data-add-to-cart-text]');
      if (btnAtcTexts.length === 0) return;

      const conditions = validateFreeFingerKit()
      if (conditions) {
        productSubmitItem?.classList?.add(classNames.HAS_FILE_UPLOAD);
      } else {
        productSubmitItem?.classList?.remove(classNames.HAS_FILE_UPLOAD);
      }

      const btnAtcText = btnAtcTexts[0]?.getAttribute('data-add-to-cart-text') || 'Add to cart';
      btnAtcTexts.forEach(btn => btn.textContent = conditions ? 'PLEASE UPLOAD FILE ABOVE' : btnAtcText);
    }

    function onVariantChange() {
      document.addEventListener('theme:variant:change', function (event) {
        const variant = event.detail.variant;
        if (!variant) return;

        const btnAtcEngraving = document.querySelector(dataSelectors.BTN_ADD_TO_CART_ENGRAVING);
        if (btnAtcEngraving) {
          if (variant.available) {
            btnAtcEngraving.removeAttribute('disabled');
          } else {
            btnAtcEngraving.setAttribute('disabled', 'disabled');
          }
        }

        updatePrintsOptionState();
      });
    }

    // Update engraving style and text, svg text layout in image
    function onChangeOptionStyle(position, style) {
      if (engravingStyleInput) engravingStyleInput.value = style
      if (inputsEngravedRow.length == 0) return;

      const currentRow = inputsEngravedRow[position];
      if (!currentRow) return;

      inputsEngravedRow.forEach(item => item.classList.remove(classNames.ACTIVE));
      currentRow.classList.add(classNames.ACTIVE);

      if (textInlineImage) textInlineImage.querySelector(`[${attributeSelectors.DATA_TEXT}]`).innerHTML = ''; // Clear previous content
      if (svgTextInlineImage) svgTextInlineImage.textContent = '';

      currentRow.querySelectorAll('input').forEach(input => {
        if (input.value) prepareInputValue(input, input.value)
      });
    }

    // Update font global drawer and value in engraving font input in form
    function onChangOptionFont(font) {
      const fontIndex = fonts.indexOf(font);
      if (drawerContent) drawerContent.setAttribute('data-font-index', fontIndex);
      if (engravingFontInput) engravingFontInput.value = font
    }

    function onChangeEngravingInput() {
      if (!textInlineImage) return;
      inputsEngraved.forEach(input => {
        input.addEventListener('input', function () {
          prepareInputValue(input, this.value)
        })

        const self = this;

        input.addEventListener('change', function () {
          // Update all inputs with the same data-index
          const dataIndex = this.getAttribute(attributeSelectors.DATA_IE_INDEX);
          const selector = `${dataSelectors.DATA_INPUT_ENGRAVED_ROW} [${attributeSelectors.DATA_IE_INDEX}="${dataIndex}"]`;
          const inputsSameIndex = self.container.querySelectorAll(selector);
          inputsSameIndex.forEach(item => { item.value = this.value })
        })
      })
    }


    function prepareInputValue(input, value) {
      const dataIndex = input.getAttribute(attributeSelectors.DATA_IE_INDEX);
      const dataTextType = input.getAttribute(attributeSelectors.DATA_IE_TEXT_TYPE);
      if (input.id == 'dob_character' && svgTextInlineImage) {
        svgTextInlineImage.textContent = value;
        return
      }
      appendTextInlineImage(value, dataIndex, dataTextType)
    }

    function appendTextInlineImage(text, dataIndex, dataTextType) {
      if (!textInlineImage.querySelector('.text')) {
        const spanPrint = (content) => `<span class="text flex flex-col" ${attributeSelectors.DATA_IE_TEXT_TYPE}="${dataTextType}">${content}</span>`
        let inlineTextHtml = ''
        switch (dataTextType) {
          case 'two_lines_with_dob':
          case 'two_lines':
            inlineTextHtml = spanPrint(`<span ${attributeSelectors.DATA_INDEX}="1"></span><span ${attributeSelectors.DATA_INDEX}="2"></span>`)
            break;
          case 'two_lines_with_&':
            inlineTextHtml = spanPrint(`<span ${attributeSelectors.DATA_INDEX}="1"></span><span>&</span><span ${attributeSelectors.DATA_INDEX}="2"></span>`)
            break;
          case 'two_lines_with_+':
            inlineTextHtml = spanPrint(`<span ${attributeSelectors.DATA_INDEX}="1"></span><span>+</span><span ${attributeSelectors.DATA_INDEX}="2"></span>`)
            break;
          case 'three_lines':
            inlineTextHtml = spanPrint(`<span ${attributeSelectors.DATA_INDEX}="1"></span><span ${attributeSelectors.DATA_INDEX}="2"></span><span ${attributeSelectors.DATA_INDEX}="3"></span>`)
            break;
          case 'three_lines_with_+':
            inlineTextHtml = spanPrint(`<span ${attributeSelectors.DATA_INDEX}="1"></span><span>+</span><span ${attributeSelectors.DATA_INDEX}="2"></span><span>+</span><span ${attributeSelectors.DATA_INDEX}="3"></span>`)
            break;
          default:
            inlineTextHtml = spanPrint(`<span ${attributeSelectors.DATA_INDEX}="1"></span>`)
        }

        textInlineImage.querySelector(`[${attributeSelectors.DATA_TEXT}]`).innerHTML = inlineTextHtml;
      }

      const targetSpan = textInlineImage.querySelector(`.text [${attributeSelectors.DATA_INDEX}="${dataIndex}"]`);
      if (targetSpan) {
        targetSpan.textContent = text;
      }

      const editableSpans = textInlineImage.querySelectorAll(`.text [${attributeSelectors.DATA_INDEX}]`);
      let maxLength = 0;
      editableSpans.forEach(span => {
        const len = (span.textContent || '').length;
        if (len > maxLength) {
          maxLength = len;
      }
      });

      const allChildSpans = textInlineImage.querySelectorAll('.text > span');
      allChildSpans.forEach(span => {
        if (maxLength > 0) {
          span.setAttribute('data-text-size', maxLength);
        } else {
          span.removeAttribute('data-text-size');
        }
      });
    }

    // Fingerprint FAQs Modal
    function openFingerprintFAQModal() {
      const btnInfoFingerprint = this.container.querySelector(productSelectors.BTN_INFO_FINGERPRINT);

      if (btnInfoFingerprint) {
        btnInfoFingerprint.addEventListener('click', function (event) {
          event.preventDefault();
          const btnFingerprintFAQ = document.querySelector(dataSelectors.BTN_FINGERPRINT_FAQ_MODAL);
          btnFingerprintFAQ.click();
        });
      }
    }

    // Size guide table toggle
    const switchButton = this.container.querySelector(`${dataSelectors.SIZE_GUIDE_SWITCH_CONTENT} input`);
    const guideItemContents = this.container.querySelectorAll(dataSelectors.SIZE_GUIDE_ITEM_CONTENT);

    function toggleGuideTable(textCompare) {
      const guideTableThs = this.container.querySelectorAll(`${productSelectors.SIZE_GUIDE_MODAL} th`);
      const guideTableTrs = this.container.querySelectorAll(`${productSelectors.SIZE_GUIDE_MODAL} table tr`);
      let currentIndex = -1
      guideTableThs.forEach((th, index) => {
        if (th.textContent.trim().includes(textCompare)) {
          th.classList.add(classNames.HIDDEN);
          currentIndex = index
        } else {
          th.classList.remove(classNames.HIDDEN);
        }
      })

      guideTableTrs.forEach((tr) => {
        const tds = tr.querySelectorAll('td');
        tds.forEach((td, index) => {
          if (index === currentIndex) {
            td.classList.add(classNames.HIDDEN);
          } else {
            td.classList.remove(classNames.HIDDEN);
          }
        })
      })
    }

    if (switchButton) {
      switchButton.addEventListener('click', function () {
        guideItemContents.forEach(content => {
          content.classList.toggle(classNames.HIDDEN);
        })

        if (this.checked) {
          toggleGuideTable('Inner Diameter');
        } else {
          toggleGuideTable('Circumference');
        }
      });
    }

    function isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }

    if (isIOS()) {
      document.body.classList.add('is-ios');
    }

    // Double side dropdown events
    document.addEventListener('theme:product:double_side_selected', () => {
      updatePrintsOptionState();
    });

    // Run initially in case of pre-selected values
    updatePrintsOptionState();
  });

  class PopupSelect extends HTMLElement {
    constructor() {
      super();

      this.container = document.querySelector(productSelectors.PRODUCT_INNER_WRAPPER);
      this.popupContainer = this.querySelector(popupSelectSelectors.CONTAINER);
      this.trigger = this.querySelector(popupSelectSelectors.TRIGGER);
      this.popup = this.querySelector(popupSelectSelectors.POPUP);
      this.options = this.querySelectorAll(popupSelectSelectors.OPTION);
      this.selectedOption = this.querySelector(popupSelectSelectors.SELECTED_OPTION);
      this.hiddenInput = this.querySelector(popupSelectSelectors.HIDDEN_INPUT);
      this.selectedImage = this.querySelector(popupSelectSelectors.SELECTED_IMAGE);
      this.popupType = this.getAttribute(popupSelectSelectors.DATA_POPUP_TYPE) || '';
      this.popupIndex = this.getAttribute(popupSelectSelectors.DATA_POPUP_INDEX) || '1'

      this.isOpen = false;

      this.init();
    }

    init() {
      this.trigger.addEventListener('click', this.togglePopup.bind(this));

      // Close popup when clicking outside
      this.popupContainer.addEventListener('click', (event) => {
        if (!this.contains(event.target) && this.isOpen) {
          this.closePopup();
        }
      });

      // Add click event to options
      this.options.forEach(option => {
        option.addEventListener('click', () => {
          this.selectOption(option);
        });
      });

      // Set initial selected option if available
      const initialSelected = this.querySelector(popupSelectSelectors.INITIAL_SELECTED);
      if (initialSelected) {
        this.selectOption(initialSelected, false);
      }
    }

    togglePopup() {
      if (this.isOpen) {
        this.closePopup();
      } else {
        this.openPopup();
      }
    }

    openPopup() {
      this.popup.classList.add(classNames.ACTIVE);
      this.trigger.setAttribute('aria-expanded', 'true');
      this.isOpen = true;
    }

    closePopup() {
      this.popup.classList.remove(classNames.ACTIVE);
      this.trigger.setAttribute('aria-expanded', 'false');
      this.isOpen = false;
    }

    selectOption(option, closeAfterSelect = true) {
      // Remove selected class from all options
      this.options.forEach(opt => opt.classList.remove(classNames.SELECTED));

      // Add selected class to clicked option
      option.classList.add(classNames.SELECTED);

      // Update trigger text with selected option
      const isDefault = option.getAttribute(popupSelectSelectors.OPTION_DEFAULT);
      const variantID = option.getAttribute(popupSelectSelectors.VARIANT_ID);
      const variantPrice = option.getAttribute(popupSelectSelectors.VARIANT_PRICE);
      const text = option.textContent.trim();
      const imageOption = option.querySelector(popupSelectSelectors.DATA_IMAGE_OPTION);
      this.selectedImage.innerHTML = imageOption ? imageOption.innerHTML : ''
      this.selectedOption.textContent = text;

      if (isDefault) {
        this.selectedOption.classList.remove(classNames.SELECTED);
      } else {
        this.selectedOption.classList.add(classNames.SELECTED);
      }

      // Update hidden input value
      if (this.hiddenInput) {
        this.hiddenInput.value = variantID;

        // Dispatch change event
        const event = new Event('change', { bubbles: true });
        this.hiddenInput.dispatchEvent(event);
      }

      if (this.popupType === 'birthstone') {
        this.updateBirthStonePopup(isDefault, variantID, variantPrice);
      } else if (this.popupType === 'double-sides') {
        const url = this.selectedImage.querySelector('img').getAttribute('src')
        this.updateDoubleSidePopup(text, url);
      }

      // Close popup after selection
      if (closeAfterSelect) {
        this.closePopup();
      }
    }

    updateBirthStonePopup(isDefault, variantID, variantPrice) {
      const birthstoneOptionInputs = this.container.querySelectorAll(dataSelectors.INPUT_BIRTHSTONE);
      birthstoneOptionInputs.forEach(input => {
        input.name = isDefault ? '' : 'items[1][id]'
        input.value = variantID
      });

      // Dispatch change price button atc
      document.dispatchEvent(
        new CustomEvent('theme:cart:add_birthstone', {
          detail: {
            price: variantPrice
          },
          bubbles: false,
        })
      );
    }

    updateDoubleSidePopup(text, url) {
      if (!url || !text) return;

      const isFirst = this.popupIndex === '1';
      const normalizedText = text.toLowerCase().trim();
      const imageType = normalizedText.replace(/\s+/g, '_');

      const isMediumSize = ['footprint', 'handprint', 'paw_print'].includes(imageType);

      const wrapper = document.querySelector(
        isFirst
          ? '[data-ds-image-inline-first]'
          : '[data-ds-image-inline-second]'
      );

      if (wrapper) {
        wrapper.classList.add('hidden')
        wrapper.dataset.imageType = isMediumSize ? 'medium' : 'small';
      }

      const mapping = {
        'classic fingerprint': { type: 'Fingerprint', quantity: '1' },
        'duo fingerprint': { type: 'Fingerprint', quantity: '2' },
        'heart duo fingerprint': { type: 'Fingerprint', quantity: '2' },
        'trio fingerprint': { type: 'Fingerprint', quantity: '3' },
        'handwriting': { type: 'Handwritten', quantity: '1' },
        'handprint': { type: 'Handprint', quantity: '1' },
        'footprint': { type: 'Footprint', quantity: '1' },
        'paw print': { type: 'Paw Print', quantity: '1' }
      };

      const result = mapping[normalizedText] || { type: text, quantity: '1' };

      const inputType = this.container?.querySelector(
        isFirst ? '[data-input-front-engraving-type]' : '[data-input-back-engraving-type]'
      );
      const inputQuantity = this.container?.querySelector(
        isFirst ? '[data-input-front-engraving-quantity]' : '[data-input-back-engraving-quantity]'
      );

      const image = wrapper?.querySelector('img');

      if (inputType) inputType.value = image ? text : '';
      if (inputQuantity) inputQuantity.value = image ? result.quantity : '';
      
      if (!image) return;

      image.src = url;
      setTimeout(() => {
        image.classList.remove('hidden');
        wrapper.classList.remove('hidden')
      }, 200);

      

      document.dispatchEvent(
        new CustomEvent('theme:product:double_side_selected', {
          detail: {
            double_side_index: this.popupIndex,
            double_side_type: normalizedText
          }
        })
      );
    }
  }

  customElements.define("popup-select", PopupSelect);

  class CustomDots extends HTMLElement {
    constructor() {
      super();

      this.container = document.querySelector(productSelectors.PRODUCT_INNER_WRAPPER);
      this.thumbnails = this.container.querySelectorAll('[data-thumb-item]');
      this.customDotItems = this.container.querySelectorAll('[data-custom-dot-item]');

      this.init();
    }

    init() {
      const self = this

      this.thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', function () {
          const currentIndex = this.dataset.currentThumbIndex
          self.customDotItems.forEach((dot, index) => {
            if (index == currentIndex) {
              dot.classList.add(classNames.ACTIVE);
            } else {
              dot.classList.remove(classNames.ACTIVE);
            }
          })
        });
      })
    }
  }

  customElements.define("custom-dots", CustomDots);

  class SelectorBoxs extends HTMLElement {
    constructor() {
      super();

      this.container = document.querySelector(productSelectors.PRODUCT_INNER_WRAPPER);
      this.radioInputs = this.querySelectorAll('.radio__input');
      this.uploadFileEl = this.querySelector(dataSelectors.INPUT_FINGERPRINT);
      this.uploadMethodSelectors = this.querySelector('upload-method-selectors');
      this.selectorIndex = this.getAttribute('data-selector-index') || '1'
      this.selectorHeader = this.querySelector('[data-selector-header]');

      this.init()
    }

    init() {
      this.initInputs();
      this.bindDoubleSideEvents();
    }

    initInputs() {
      this.radioInputs.forEach(input => {
        if (input.checked) {
          this.validateUploadStatus(input);
        }

        input.addEventListener('change', () => {
          this.validateUploadStatus(input);
        });
      });
    }

    validateUploadStatus(input) {
      const isHidden = input.value.toLowerCase().includes('yes');

      this.uploadMethodSelectors.setAttribute('data-hidden', isHidden);
    }

    bindDoubleSideEvents() {
      document.addEventListener('theme:product:double_side_selected', (event) => {
        const { double_side_index, double_side_type } = event.detail;
        const isHandwrinting = double_side_type === 'handwriting';

        if (double_side_index === this.selectorIndex) {
          this.setAttribute('data-hidden', 'false');
          this.selectorHeader.setAttribute('data-hidden', isHandwrinting);
        }

        // this.selectorHeader.setAttribute('data-hidden', isHandwrinting);
      });
    }
  }

  customElements.define("selector-boxs", SelectorBoxs);

  class UploadMethodSelectors extends HTMLElement {
    constructor() {
      super();

      this.tabLinks = [...this.querySelectorAll('[data-fingerprint-tab]')];
      this.tabContents = [...this.querySelectorAll('.fingerprint-tab__content')];
      this.inputFile = this.querySelector('#fingerprint_upload_file');
      this.inputOrder = this.querySelector('#fingerprint_order_number');
      this.uploadWrapper = this.querySelector('[data-fingerprint-upload]');
      this.productSubmitItem = document.querySelector('.js-product-submit-item');
      this.btnAtcTexts = [...document.querySelectorAll('[data-add-to-cart-text]')];
      this.uploadLater = this.getAttribute('data-upload-later') === 'true';

      this.currentTab = 0;

      this.init();
    }

    init() {
      this.initTabs();
      this.initInputs();
      this.bindAddToCartEvent();
      this.updateBtnAddToCart();
    }

    bindAddToCartEvent() {
      document.addEventListener('theme:product:add', () => {
        this.resetInputs();
        this.updateBtnAddToCart();
      });
    }

    initInputs() {
      document
        .querySelectorAll('[name="free_fingerprint_kit_name"]')
        .forEach(input => {
          if (input.checked && input.value === 'No') {
            this.updateBtnAddToCart();
          }
        });

      this.inputFile?.addEventListener('change', () => {
        this.inputFile.parentElement?.classList.add('uploaded');
        this.updateBtnAddToCart();
      });

      this.inputOrder?.addEventListener('input', () => {
        this.updateBtnAddToCart();
      });
    }

    initTabs() {
      this.tabLinks.forEach(tab => {
        tab.addEventListener('click', () => {
          this.switchTab(Number(tab.dataset.tab));
        });
      });
    }

    switchTab(tabIndex) {
      this.currentTab = tabIndex;

      this.tabLinks.forEach(link =>
        link.classList.toggle('current', Number(link.dataset.tab) === tabIndex)
      );

      this.tabContents.forEach((content, index) =>
        content.classList.toggle('current', index === tabIndex)
      );

      this.updateBtnAddToCart();
    }

    resetInputs() {
      if (this.inputFile) {
        this.inputFile.value = '';
        this.inputFile.parentElement?.classList.remove('uploaded');
      }
      if (this.inputOrder) {
        this.inputOrder.value = '';
      }
    }

    isValid() {
      if (this.currentTab === 0) {
        return Boolean(this.inputFile?.value);
      }
      return this.inputOrder?.value?.length >= 5;
    }

    updateBtnAddToCart() {
      if (!this.btnAtcTexts.length || this.uploadLater) return;

      const isValid = this.isValid();
      const btnText = isValid
        ? this.btnAtcTexts[0].dataset.addToCartText || 'Add to cart'
        : 'PLEASE UPLOAD FILE ABOVE';

      this.uploadWrapper?.setAttribute('data-has-value', isValid);
      this.productSubmitItem?.classList.toggle('has-file-upload', !isValid);

      this.btnAtcTexts.forEach(btn => (btn.textContent = btnText));
    }
  }

  customElements.define("upload-method-selectors", UploadMethodSelectors);

})();
